/**
 * Payment methods allowed in a specific restaurant.
 */
export enum PaymentMethod {
  Card = "Carte bancaire",
  Cash = "Espèce",
  Izly = "IZLY",
  Moneo = "Monéo"
}
